import { createApi, DefaultResponsePlugin, LanguageHeaderPlugin } from '@core';
import { AutocompleteApi, TranslationsApi, ValidatorApi } from '../modules/base';
import { AuthApi, AuthHeaderPlugin, RefreshTokenPlugin } from '../modules/auth';
import { HtmlContentApi } from '../modules/html-content';
import { CropApi } from '../modules/crop';
import { OfferCalculatorApi } from '../modules/offer-calculator';

const modules = {
  auth: new AuthApi(),
  autocomplete: new AutocompleteApi(),
  htmlContent: new HtmlContentApi(),
  translation: new TranslationsApi(),
  validator: new ValidatorApi(),
  crop: new CropApi(),
  offerCalculator: new OfferCalculatorApi()
};
0;

const sharedApi = createApi({ modules });
sharedApi.registerPlugins([DefaultResponsePlugin, AuthHeaderPlugin, RefreshTokenPlugin, LanguageHeaderPlugin]);

export const useSharedApi = () => sharedApi.getModules();
